import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { brandPrimaryHoverTint, darkGrayFontColor, titles, white } from '../../../../styles/colors';

export const styles = StyleSheet.create({
	modal: {
		position: 'relative' as const,
	},
	modalHeaderCloseButton: {
		position: 'absolute' as const,
		top: 0,
		right: 0,
	},
	modalContainer: {
		padding: THEME.spacing.lg,
		minWidth: 700,
		maxHeight: '80vh',
		overflowY: 'auto' as const,
	},
	container: {
		padding: THEME.spacing.lg,
	},
	header: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.md,
		marginBottom: THEME.spacing.xl,
	},
	headerIcon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
	},
	headerContent: {
		flex: 1,
	},
	title: {
		fontSize: 24,
		fontWeight: 600,
		margin: 0,
		marginBottom: THEME.spacing.sm,
		color: titles,
	},
	description: {
		fontSize: 14,
		color: darkGrayFontColor,
		margin: 0,
	},
	headerActions: {
		display: 'flex',
		gap: THEME.spacing.sm,
		flexShrink: 0,
	},
	tableWrapper: {
		width: '100%',
		height: '100%',
		overflowX: 'auto',
		overflowY: 'auto',
		background: white,
		maxWidth: '100vw',
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
	},
	table: {
		width: '100%',
		borderCollapse: 'separate',
		borderSpacing: 0,
		paddingTop: 0,
		paddingBottom: 0,
		border: 0,
	},
	tableHeaderCell: {
		background: brandPrimaryHoverTint,
		minWidth: 150,
		position: 'relative',
	},
	tableHeaderCellActions: {
		textAlign: 'right' as const,
	},
	tableRow: {},
	tableCell: {
		padding: '12px 16px',
		fontSize: 14,
		color: titles,
		verticalAlign: 'middle' as const,
	},
	tableCellActions: {
		padding: '12px 16px',
		textAlign: 'right' as const,
		verticalAlign: 'middle' as const,
	},
	tableCellType: {
		padding: '12px 8px',
		fontSize: 14,
		color: titles,
		verticalAlign: 'middle' as const,
		textAlign: 'left' as const,
	},
	actionButtons: {
		display: 'flex',
		gap: 8,
		justifyContent: 'flex-end',
	},
	emptyState: {
		padding: 40,
		textAlign: 'center' as const,
		color: '#6b7280',
	},
	modalHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: THEME.spacing.lg,
		paddingBottom: THEME.spacing.md,
	},
	modalTitle: {
		fontSize: 18,
		margin: 0,
		color: THEME.colors.primary.main,
	},
	builtInLabel: {
		marginLeft: THEME.spacing.sm,
		fontSize: THEME.typography.fontSizes.xxs,
		color: darkGrayFontColor,
		fontWeight: 'normal',
	},
	formGroup: {
		marginBottom: THEME.spacing.lg,
	},
	featureSection: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: white,
		padding: THEME.spacing.md,
		marginBottom: THEME.spacing.md,
	},
	featureSectionTitle: {
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: 600,
		marginBottom: THEME.spacing.sm,
		color: titles,
	},
	permissionCheckboxGroup: {
		display: 'flex',
		flexWrap: 'wrap' as const,
		gap: THEME.spacing.lg,
	},
	permissionCheckboxItem: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
	},
	permissionCheckboxLabel: {
		fontSize: 14,
		color: titles,
		cursor: 'pointer',
	},
	surveyTypeRow: {
		paddingTop: THEME.spacing.sm,
		paddingBottom: THEME.spacing.sm,
		borderTop: THEME.common.border,
		':first-child': {
			paddingTop: 0,
			borderTop: 'none',
		},
	},
	surveyTypeName: {
		fontSize: 14,
		fontWeight: 500,
		marginBottom: THEME.spacing.xs,
		color: titles,
	},
	modalActions: {
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'flex-start',
		marginTop: THEME.spacing.xl,
		paddingTop: THEME.spacing.md,
	},
	tableDataCellDisabled: {
		// @ts-expect-error -- this is a hack to allow the button to show the correct cursor when disabled
		pointerEvents: 'auto !important',
		cursor: 'not-allowed',
	},
});
